<template>
  <v-app id="portal">
    <v-content class="px-2">
      <titulo-responsivo
        :titulo="locale[local].screen.marcacoesPonto.string001"
      />
      <v-divider />
      <template>
        <div class="d-flex justify-center">
          <v-chip-group
            mandatory
            active-class="white--text primary "
            v-model="codigo"
          >
            <v-chip
              v-for="option in filterOptions"
              :key="option.codigo"
              @click="setFilterOption(option.codigo)"
            >
              {{ option.descricao }}
            </v-chip>
          </v-chip-group>
        </div>
      </template>

      <div class="d-flex justify-center pt-4">
        <v-card v-if="loading" width="1200">
          <v-card-text>
            <v-skeleton-loader
              v-model="loading"
              type="article, article, article, article, article, article"
            ></v-skeleton-loader>
          </v-card-text>
        </v-card>

        <v-card v-else width="1200">
          <v-card-title class="pa-6">
            <v-text-field
              readonly
              :value="codEmpregado"
              :label="locale[local].screen.marcacoesPonto.string002"
              style="width: 100px"
            >
            </v-text-field>
            <v-text-field
              readonly
              :value="unidade"
              :label="locale[local].screen.marcacoesPonto.string003"
              class="pl-6"
            >
            </v-text-field>
            <v-text-field
              readonly
              :value="cargo"
              :label="locale[local].screen.marcacoesPonto.string004"
              class="pl-6"
            >
            </v-text-field>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="cabecalho"
            :items="items"
            hide-default-footer
            disable-pagination
            dense
          >
            <template v-slot:[`item.dtMovto`]="{ item }">
              {{
                item.dtMovto
                  ? moment(item.dtMovto).format("DD/MM/YYYY")
                  : "Sem data informada"
              }}
            </template>
          </v-data-table>
        </v-card>
      </div>

      <v-row
        v-show="mostraTotais"
        class="px-2"
        justify="center"
        align="end"
        dense
      >
        <v-col
          v-show="he50 != '    00:00 '"
          class="px-1"
          cols="12"
          lg="2"
          xs="1"
        >
          <v-card height="10vh" color="blue" class="white--text">
            <v-container fill-height fluid>
              <v-row>
                <v-col>
                  {{ locale[local].screen.marcacoesPonto.string005 }}
                  <br />
                  <span style="font-size: 35px"
                    ><strong>{{ he50 }}</strong>
                  </span>
                </v-col>
                <br />
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col
          v-show="he60 != '    00:00 '"
          class="px-1"
          cols="12"
          lg="2"
          xs="1"
        >
          <v-card height="10vh" color="blue" class="white--text">
            <v-container fill-height fluid>
              <v-row>
                <v-col>
                  {{ locale[local].screen.marcacoesPonto.string009 }}
                  <br />
                  <span style="font-size: 35px"
                    ><strong>{{ he60 }}</strong>
                  </span>
                </v-col>
                <br />
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col class="px-1" cols="12" lg="2" xs="1">
          <v-card height="10vh" color="green" class="white--text">
            <v-container fill-height fluid>
              <v-row>
                <v-col>
                  {{ locale[local].screen.marcacoesPonto.string006 }}
                  <br />
                  <span style="font-size: 35px"
                    ><strong>{{ he100 }}</strong></span
                  >
                  <br />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col class="px-1" cols="12" lg="2" xs="1">
          <v-card height="10vh" color="orange" class="white--text">
            <v-container fill-height fluid>
              <v-row>
                <v-col>
                  {{ locale[local].screen.marcacoesPonto.string007 }}
                  <br />
                  <span style="font-size: 35px"
                    ><strong>{{ faltaJust }}</strong></span
                  >
                  <br />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col class="px-1" cols="12" lg="2" xs="1">
          <v-card height="10vh" color="red" class="white--text">
            <v-container fill-height fluid>
              <v-row>
                <v-col>
                  {{ locale[local].screen.marcacoesPonto.string008 }}
                  <br />
                  <span style="font-size: 35px"
                    ><strong>{{ faltaInsjut }}</strong></span
                  >
                  <br />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>

        <v-col
          v-show="banco != ''"
          class="px-1"
          cols="12"
          lg="2"
          xs="1"
        >
          <v-card height="10vh" color="blue" class="white--text">
            <v-container fill-height fluid>
              <v-row>
                <v-col>
                  {{ locale[local].screen.marcacoesPonto.string010 }}
                  <br />
                  <span style="font-size: 35px"
                    ><strong>{{ banco }}</strong>
                  </span>
                </v-col>
                <br />
              </v-row>
            </v-container>
          </v-card>
        </v-col>

      </v-row>
    </v-content>
  </v-app>
</template>

<script>
import Service from "@/components/api/Service";
import { locale } from "../locale/locale";

export default {
  data: () => ({
    service: new Service(),
    loading: false,
    codEmpregado: 0,
    unidade: "",
    cargo: "",
    codigo: 1,
    filterOptions: [
      { codigo: 0, descricao: "Mês Anterior" },
      { codigo: 1, descricao: "Mês Atual" },
    ],
    cabecalho: [
      {
        text: locale[window.local].screen.marcacoesPonto.table01.header01,
        align: "start",
        sortable: false,
        value: "dtMovto",
        divider: true,
        width: "15%",
        custom: true,
      },
      {
        text: locale[window.local].screen.marcacoesPonto.table01.header02,
        align: "start",
        sortable: false,
        value: "diaSemana",
        divider: true,
        width: "15%",
      },
      {
        text: locale[window.local].screen.marcacoesPonto.table01.header03,
        align: "start",
        sortable: false,
        value: "horario",
        divider: true,
        width: "35%",
      },
      {
        text: locale[window.local].screen.marcacoesPonto.table01.header04,
        align: "start",
        sortable: false,
        value: "marcacoes",
        divider: true,
        width: "35%",
      },
    ],
    items: [],
    horasTotal: [],
    he50: "",
    he60: "",
    he100: "",
    faltaJust: "",
    faltaInsjut: "",
    banco: "",
    mostraTotais: false,
    mostraTotaisHe50: false,
  }),

  async mounted() {
    this.loading = true;
    try {
      this.codigo = 1;
      this.items = await this.service.buscaMarcacaoPonto(this.codigo);
      this.codEmpregado = this.items[0].codEmpregado;
      this.unidade = this.items[0].unidade;
      this.cargo = this.items[0].cargo;
      this.horasTotal = await this.service.buscaTotPontoCalculado(this.codigo);

      if (this.horasTotal.length > 0) {
        this.mostraTotais = true;
        this.he50 = this.horasTotal[0].he50;
        this.he60 = this.horasTotal[0].he60;
        this.he100 = this.horasTotal[0].he100;
        this.faltaJust = this.horasTotal[0].faltaJust;
        this.faltaInsjut = this.horasTotal[0].faltaInjust;
        this.banco = this.horasTotal[0].saldoBanco;
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async setFilterOption(codigo) {
      this.items = await this.service.buscaMarcacaoPonto(codigo);
      this.codEmpregado = this.items[0].codEmpregado;
      this.unidade = this.items[0].unidade;
      this.cargo = this.items[0].cargo;
      this.horasTotal = await this.service.buscaTotPontoCalculado(codigo);

      if (this.horasTotal.length > 0) {
        this.mostraTotais = true;
        this.he50 = this.horasTotal[0].he50;
        this.he60 = this.horasTotal[0].he60;
        this.he100 = this.horasTotal[0].he100;
        this.faltaJust = this.horasTotal[0].faltaJust;
        this.faltaInsjut = this.horasTotal[0].faltaInjust;
        this.banco = this.horasTotal[0].saldoBanco;
      }
    },
  },
};
</script>
